import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-voip-dialog',
  templateUrl: './no-voip-dialog.component.html',
  styleUrls: ['./no-voip-dialog.component.scss']
})
export class NoVoipDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
